(function () {
  var els = document.querySelectorAll('.ap-reveal, .ap-reveal--left, .ap-reveal--right');
  if (!els.length) return;

  var isMobile = window.innerWidth < 768;
  var threshold = isMobile ? 0.18 : 0.08;
  var rootMargin = isMobile ? '0px 0px -20% 0px' : '0px';

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ap-reveal--visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: threshold, rootMargin: rootMargin }
  );

  els.forEach(function (el) { io.observe(el); });
})();

(function () {
  function initAccordions() {
    document.querySelectorAll('.accordion__details').forEach(function (details) {
      var wrapper = details.nextElementSibling;
      if (!wrapper || !wrapper.classList.contains('accordion__content-wrapper')) return;

      var summary = details.querySelector('.accordion__summary');
      if (!summary) return;

      wrapper.style.overflow = 'hidden';
      wrapper.style.display = 'block';

      if (!details.hasAttribute('open')) {
        wrapper.style.height = '0px';
        wrapper.style.opacity = '0';
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        var isOpen = details.hasAttribute('open');

        if (isOpen) {
          var h = wrapper.scrollHeight;
          wrapper.style.height = h + 'px';
          wrapper.style.opacity = '1';

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              wrapper.style.transition = 'height 0.38s cubic-bezier(0.4,0,0.2,1), opacity 0.25s ease';
              wrapper.style.height = '0px';
              wrapper.style.opacity = '0';
            });
          });

          wrapper.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'height') return;
            details.removeAttribute('open');
            wrapper.style.transition = '';
            wrapper.removeEventListener('transitionend', handler);
          });
        } else {
          details.setAttribute('open', '');
          var target = wrapper.scrollHeight;
          wrapper.style.height = '0px';
          wrapper.style.opacity = '0';

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              wrapper.style.transition = 'height 0.38s cubic-bezier(0.4,0,0.2,1), opacity 0.3s ease 0.06s';
              wrapper.style.height = target + 'px';
              wrapper.style.opacity = '1';
            });
          });

          wrapper.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'height') return;
            wrapper.style.height = '';
            wrapper.style.transition = '';
            wrapper.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();
